module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400.woff2?33543c5cc5d88f5695dd08c87d280dfd";